<section class="tw-bg-[#F7F7F7] tw-py-10 tw-px-4 lg:tw-px-20">
    <div
        class="content tw-max-w-[1220px] tw-mx-auto tw-px-[15px] tw-items-center"
    >
        <h2
            class="tw-text-center !tw-text-[28px] md:!tw-text-[40px] tw-w-full tw-text-[#0F3172] !tw-mb-[25px] !tw-font-bold"
        >
            {{ "COMMON.WHATS_NEW" | translate }}
        </h2>
        <div
            data-sal="slide-up"
            data-sal-delay="500"
            data-sal-duration="1000"
            class=""
        >
            <ngx-slick-carousel
                class="carousel what-new"
                [config]="slideConfig"
            >
                <div
                    ngxSlickItem
                    *ngFor="let data of whatsNewData"
                    class="slide"
                >
                    <div
                        class="tw-relative tw-cursor-pointer tw-w-full tw-max-w-[280px] tw-mx-auto"
                        (click)="whatsNewDetails(data)"
                    >
                        <div
                            *ngIf="data?.campaigndetails?.promoHat"
                            class="tw-absolute tw-left-0 tw-top-4 tw-bg-[#FF13BC] tw-text-[#FFFFFF] tw-text-[14px] tw-font-bold tw-py-1 tw-px-6 tw-text-center tw-rounded-r-full tw-z-[2] tw-content-center tw-h-[31px]"
                        >
                            {{ data?.campaigndetails?.promoHat }}
                        </div>
                        <div
                            class="tw-w-full tw-aspect-[4/3] tw-overflow-hidden tw-rounded-t-xl"
                        >
                            <img
                                [attr.ga-event-id]="
                                    data?.campaigndetails?.campaignName +
                                    '_whatsnew_card_homepage_click'
                                "
                                ga-event-category="Homepage Button"
                                [attr.ga-event-label]="
                                    data?.campaigndetails?.campaignName +
                                    ' What\'s New Card Click'
                                "
                                ga-track="track"
                                [src]="data?.campaigndetails?.campaignImageUrl"
                                alt="Whats New"
                                class="tw-w-full tw-h-full tw-object-cover"
                            />
                        </div>
                        <div
                            class="tw-flex tw-flex-col tw-px-7 tw-py-5 tw-rounded-xl tw-h-[164px]"
                            style="
                                background: linear-gradient(
                                    179.68deg,
                                    rgba(198, 198, 198, 0) 3.29%,
                                    #e5e5e5 63.2%
                                );
                            "
                        >
                            <span
                                [attr.ga-event-id]="
                                    data?.campaigndetails?.campaignName +
                                    '_whatsnew_card_homepage_click'
                                "
                                ga-event-category="Homepage Button"
                                [attr.ga-event-label]="
                                    data?.campaigndetails?.campaignName +
                                    ' What\'s New Card Click'
                                "
                                ga-track="track"
                                class="tw-text-[#002D86] tw-font-bold tw-mb-2 tw-text-[16px] tw-break-words"
                                [innerHTML]="
                                    truncate(
                                        removeHtmlTags(
                                            data?.campaigndetails?.campaignName
                                        ),
                                        50
                                    )
                                "
                            ></span>
                            <span
                                [attr.ga-event-id]="
                                    data?.campaigndetails?.campaignName +
                                    '_whatsnew_card_homepage_click'
                                "
                                ga-event-category="Homepage Button"
                                [attr.ga-event-label]="
                                    data?.campaigndetails?.campaignName +
                                    ' What\'s New Card Click'
                                "
                                ga-track="track"
                                class="tw-text-[#2B2B2B] tw-text-[13px] content-details default-html tw-break-words"
                                [innerHTML]="
                                    truncate(
                                        data?.campaigndetails
                                            ?.campaignDescription,
                                        110
                                    )
                                "
                            ></span>
                        </div>
                    </div>
                </div>
            </ngx-slick-carousel>
        </div>
    </div>
</section>
